/**
 * Product form: variant cards, quantity stepper, dynamic total, Order Now (Buy it now).
 * Uses event delegation where useful. Re-runs on shopify:section:load for theme editor.
 */
(function () {
  function formatMoney(cents, moneyFormat) {
    if (moneyFormat == null || moneyFormat === '') {
      return (cents / 100).toFixed(2);
    }
    moneyFormat = String(moneyFormat).replace(/\bRs\.?\s*/gi, '₹ ');
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(/\./, ','));
  }

  function findForm(root) {
    if (!root || !root.querySelector) return null;
    return root.querySelector('[data-product-form]') || root.querySelector('form.product-form');
  }

  function initProductForm(container) {
    var form = container ? findForm(container) : findForm(document);
    if (!form || form._productFormInit) return;
    form._productFormInit = true;

    var variantInput = form.querySelector('[data-variant-input]');
    var priceEl = container
      ? container.querySelector('[data-product-price]')
      : document.querySelector('[data-product-price]');
    var quantityInput = form.querySelector('[data-quantity-input]');
    var totalPriceEl = form.querySelector('[data-total-price]');
    var totalWrap = form.querySelector('[data-total-wrap]');
    var variantCards = form.querySelectorAll('[data-variant-card]');
    var minusBtn = form.querySelector('[data-quantity-minus]');
    var plusBtn = form.querySelector('[data-quantity-plus]');
    var orderNowBtn = form.querySelector('[data-order-now]');
    var variantHint = form.querySelector('[data-variant-hint]');

    var addToCartRef = form.querySelector('[data-add-to-cart-ref]');
    var addToCartBtn = form.querySelector('[data-add-to-cart-btn]');
    var moneyFormat = (addToCartRef && addToCartRef.getAttribute('data-money-format')) || form.getAttribute('data-money-format') || '';

    function getQuantity() {
      var q = parseInt(quantityInput.value, 10);
      return isNaN(q) || q < 1 ? 1 : Math.min(99, q);
    }

    function setQuantity(q) {
      q = Math.max(1, Math.min(99, q));
      quantityInput.value = String(q);
      updateTotal();
    }

    function getVariantPrice() {
      var id = variantInput && variantInput.value;
      if (!id) return 0;
      var card = form.querySelector('[data-variant-card][data-variant-id="' + id + '"]');
      if (!card) return 0;
      var price = card.getAttribute('data-variant-price');
      return price ? parseInt(price, 10) : 0;
    }

    function updateTotal() {
      var price = getVariantPrice();
      var q = getQuantity();
      var totalCents = price * q;
      if (totalPriceEl) {
        totalPriceEl.textContent = formatMoney(totalCents, moneyFormat);
      }
      if (totalWrap) {
        totalWrap.hidden = false;
      }
    }

    function enablePurchaseButtons() {
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute('aria-disabled');
        addToCartBtn.classList.remove('is-loading');
      }
      if (orderNowBtn) {
        orderNowBtn.disabled = false;
        orderNowBtn.removeAttribute('aria-disabled');
        orderNowBtn.classList.remove('is-loading');
      }
    }

    function setVariant(variantId) {
      if (variantInput) variantInput.value = variantId;
      var selectedCard = null;
      variantCards.forEach(function (card) {
        var isActive = card.getAttribute('data-variant-id') === String(variantId);
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) selectedCard = card;
      });
      if (priceEl && selectedCard) {
        var price = selectedCard.getAttribute('data-variant-price');
        if (price) priceEl.textContent = formatMoney(parseInt(price, 10), moneyFormat);
      }

      var compareEl = container
  ? container.querySelector('.main-compare-price')
  : document.querySelector('.main-compare-price');
      if (compareEl && selectedCard) {
        var comparePriceText = selectedCard.querySelector('.variant-compare-price');
        if (comparePriceText) {
          compareEl.innerHTML = comparePriceText.innerHTML;
          compareEl.style.display = '';
        } else {
          compareEl.innerHTML = '';
          compareEl.style.display = 'none';
        }
      }

      if (selectedCard) {
        enablePurchaseButtons();
        if (variantHint) variantHint.hidden = true;
      }

      updateTotal();
    }

    function restoreAfterReturn() {
      var selectedId = variantInput ? String(variantInput.value || '').trim() : '';
      if (selectedId) {
        setVariant(selectedId);
        return;
      }
      enablePurchaseButtons();
      updateTotal();
    }

    form._restorePurchaseState = restoreAfterReturn;

    variantCards.forEach(function (card) {
      card.addEventListener('click', function () {
        setVariant(card.getAttribute('data-variant-id'));
      });
    });

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        setQuantity(getQuantity() - 1);
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        setQuantity(getQuantity() + 1);
      });
    }
    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        setQuantity(getQuantity());
      });
    }

    if (orderNowBtn) {
  orderNowBtn.addEventListener('click', function () {
    if (orderNowBtn.disabled) return;

    var qty = getQuantity();
    var variantId = variantInput ? String(variantInput.value || '').trim() : '';

    if (!variantId) {
      if (variantHint) variantHint.hidden = false;
      return;
    }

    orderNowBtn.disabled = true;
    orderNowBtn.setAttribute('aria-disabled', 'true');
    orderNowBtn.classList.add('is-loading');

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    window.location.href = root + 'cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(qty);
  });
}

    var errorEl = container
      ? (container.querySelector('[data-product-form-error]') || document.querySelector('[data-product-form-error]'))
      : document.querySelector('[data-product-form-error]');

    function showAddError(message) {
      if (errorEl) {
        errorEl.textContent = message || 'Unable to add to cart. Please try again.';
        errorEl.classList.remove('visually-hidden');
      }
    }

    function clearAddError() {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.add('visually-hidden');
      }
    }

    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (!submitter || submitter.getAttribute('data-add-to-cart-btn') == null) return;
      e.preventDefault();
      clearAddError();
      var variantIdRaw = variantInput ? String(variantInput.value || '').trim() : '';
      var variantId = variantIdRaw ? parseInt(variantIdRaw, 10) : 0;
      if (!variantId || isNaN(variantId)) {
        if (variantHint) variantHint.hidden = false;
        showAddError('Please select a size to continue.');
        return;
      }
      var qty = getQuantity();
      var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') + 'cart/add.js';
      if (addToCartBtn) addToCartBtn.disabled = true;
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (addToCartBtn) addToCartBtn.disabled = false;
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('gaurya:minicart:open'));
          } else {
            var msg = (data && (data.description || data.message)) || 'This variant cannot be added. It may be sold out.';
            showAddError(msg);
          }
        });
      }).catch(function () {
        if (addToCartBtn) addToCartBtn.disabled = false;
        showAddError('Something went wrong. Please try again.');
      });
    });

    if (variantInput && variantCards.length > 0 && String(variantInput.value || '').trim() !== '') {
      setVariant(variantInput.value);
    }
    updateTotal();
  }

  function run() {
    initProductForm(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('pageshow', function () {
    var forms = document.querySelectorAll('form.product-form, [data-product-form]');
    forms.forEach(function (form) {
      if (typeof form._restorePurchaseState === 'function') {
        form._restorePurchaseState();
      }
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target;
    if (container && container.querySelector && container.querySelector('[data-product-form]')) {
      var form = container.querySelector('[data-product-form]');
      if (form) form._productFormInit = false;
      initProductForm(container);
    }
  });
})();
